import React from 'react';
import { Tooltip } from '../Wrappers/Wrappers.jsx';
import FontAwesome from 'react-fontawesome';
import { useTheme } from '@material-ui/core/styles';

export default function ExclamationTooltip ({ tooltipText }) {
    const theme = useTheme();
    return (
      <Tooltip
      placement="top"
      color="red"
      disableFocusListener
      disableTouchListener
      title={tooltipText}
      customStyle={{
        background: 'rgb(163 161 161 / 95%)',
        fontSize: 13,
        lineHeight: '1.3',
        padding: theme.spacing(2),
      }}
    >
        <FontAwesome name="exclamation-circle" />
    </Tooltip>
    );
}
